const apiBaseUrl = import.meta.env.VITE_API_URL;

interface CrashReport {
  feature: string;
  errorMessage: string;
  errorStack?: string;
  context?: Record<string, unknown>;
}

let lastReportKey = '';
let lastReportTime = 0;
const DEDUPE_WINDOW_MS = 10_000;

export function reportCrash(report: CrashReport): void {
  const key = `${report.feature}:${report.errorMessage}`;
  const now = Date.now();
  if (key === lastReportKey && now - lastReportTime < DEDUPE_WINDOW_MS) return;
  lastReportKey = key;
  lastReportTime = now;

  const payload = {
    ...report,
    userAgent: navigator.userAgent,
    url: window.location.href,
    timestamp: new Date().toISOString(),
  };

  navigator.sendBeacon?.(
    `${apiBaseUrl}/reader/crashes/report`,
    new Blob([JSON.stringify(payload)], { type: 'application/json' }),
  ) || fetch(`${apiBaseUrl}/reader/crashes/report`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
}
